import React from "react";
import Attendee from "../components/Attendee";

const AttendeePage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">    
      <Attendee />
    </div>
  );
};

export default AttendeePage;
